import * as React from 'react';
const XLogo = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    style={{ maxWidth: '17px', maxHeight: '25px' }}
    xmlns="http://www.w3.org/2000/svg"
    width="251.693"
    height="220.93"
    viewBox="0 0 251.693 220.93"
    {...props}
  >
    <path
      id="Path_5639"
      data-name="Path 5639"
      d="M323.74,148.35h36.12l-78.91,90.2,92.83,122.73H301.09l-56.93-74.43-65.15,74.43H142.87l84.4-96.47L138.22,148.35h74.53l51.46,68.04ZM311.06,339.66h20.02L201.88,168.84H180.4Z"
      transform="translate(-130.127 -144.35)"
      strokeWidth="8"
    ></path>
  </svg>
);
export default XLogo;
